import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
// import rButton from "reactstrap/button";

import {
  deleteRequest,
  putRequest,
  postRequest,
  putRequestForm,
  RBButton,
  deleteConfirmationWords,
} from "components/Common/Utils";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { format } from "date-fns";
// import StarComponent from "./StarComponent";

import Lightbox from "react-image-lightbox";
// import DayTimePicker from "./DayTimePicker";

import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";
import WareHouseProductesTable from "./WareHouseProductesTable";
import BuyProduct from "components/Modal/BuyProduct";



export default function WareHouseInventoryManage() {
  const location = useLocation();
  const _id = useParams();
  const state = location.state?.row;
  console.log(state);
  const [wareHouseData, setwareHouseData] = useState(location.state?.row);
  const [orderData, setUserOrderData] = useState({});
  const [loader, setLoader] = useState(false);
  const [imageLB, setImage] = React.useState("");
  const [images, setImages] = React.useState([]);
  const [openLightbox, setOpenLightBox] = React.useState(false);
  const [model, setModel] = useState(false);
  
  const useStyles = makeStyles({
    tableHeader: {
      color: "#ffffff", // Use your preferred color
      backgroundColor: "#3f51b5", // Header background color
      fontWeight: "bold",
    },
    descriptionText: {
      fontSize: "0.8rem",
    },
    deleteIcon: {
      color: "red",
    },
    roundImage: {
      borderRadius: "50%",
      width: "75px",
      height: "75px",
    },
    roundImageSm: {
      borderRadius: "50%",
    },

    gridList: {
      width: "100%",
    },
    icon: {
      color: "rgba(255, 55, 25, 0.54)",
    },
  });


  // useEffect(() => {
  //   fetchList();
  // }, [_id]);

  // const fetchList = async () => {
  //   setLoader(true);
  //   const payload = {
  //     orderId: _id?.id
  //   };
  //   try {
  //     const response = await postRequest(`warehouse/list-inventory`, payload);
  //     const data = response.data;
  //     setUserOrderData(data);
  //     setwareHouseData(data?.userDetail);
  //     console.log("table data", data.bannerData);
  //   } catch (error) {
  //     console.log("Failed to fetch data:", error);
  //   } finally {
  //     setLoader(false);
  //   }
  // };

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const closeModal = () => {
    setModel(false);
  };

  const selectRow = (item) => {
    console.log({ item })
    // setAssingDeliveryData({
    //   Image: item?.image,
    //   Title: item?.title,
    //   categoryId: item?._id,
    //   show: true
    // });
    // deliveryAssingOrder(item?._id);
    setModel(false);
  };

  const toggleModel = () => {
    console.log("toggleModel", model);
    setModel(!model);
  };

  // const {
  //   first_name,
  //   last_name,
  //   image,
  //   country_code,
  //   gender,
  //   country,
  //   nationality,
  //   email,
  //   mobile,
  //   dob,
  //   createdAt,
  //   address,
  // } = wareHouseData;

  console.log({ state });

  return (
    <>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>Warehouse Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">Warehouse Management</li>:{" "}
              <li className="breadcrumb-item">Warehouse Inventory List</li>
            </ol>
          </div>
        </Col>
        <div className="col-md-2 text-end">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            onClick={() => history.back()}
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>

        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >

              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
              <div
                className="cover-image"
                style={{ backgroundColor: "rgb(29, 155, 240)" }}
              ></div>
              <div className="profile-image">
                <img
                  src={`https://ui-avatars.com/api/?background=random&name=${state?.name}`}
                  onClick={() =>
                    showLightBox(`https://ui-avatars.com/api/?background=random&name=${state?.name}`
                    )
                  }
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst mt-2">
                    {" "}
                    <h3> {state?.name} </h3>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Location: <span>{state?.address}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Capacity <span> {state?.capacity} </span>{" "}
                      </p>{" "}
                    </div>


                  </div>
                </div>
              </div>
            </Card>
            <Col md="12">
              <div
                id="exTab2"
                className="twitter-like-tabs2"
                style={{ background: "#ffff", }}
              >
                <ul
                  className="nav nav-pills"
                  style={{ width: "480px", display: "contents" }}
                >
                  <li className="active">
                    <a href="#shopes" data-toggle="tab">
                      {" "}
                      Products Store List{" "}
                    </a>
                  </li>
                </ul>
              </div>
            </Col>
            <Col md="12" className="mt-4">
              <div className="tab-content clearfix">
                <div className="tab-pane active show padded-tab" id="shopes">
                  <div className="text-end mt-2 mb-2">
                    {/* <button type="button" class="btn btn-danger">
                      <i className="fal fa-shopping-cart"></i>&nbsp;
                      Purchase Products</button> */}
                  </div>
                  <WareHouseProductesTable userId={wareHouseData?._id} />
                </div>


              </div>
            </Col>

          </>
        )}

        <BuyProduct
          show={model}
          closeModal={closeModal}
          selectRow={selectRow} />

        {openLightbox && (
          <Lightbox
            mainSrc={imageLB}
            onCloseRequest={() => setOpenLightBox(false)}
          />
        )}
      </Row>
      <ToastContainer />{" "}
    </>
  );
}
